module.exports = __webpack_public_path__ + "img/invasions.5f1a1fa8.jpg";